module.exports = __webpack_public_path__ + "static/media/tailwindcss-icon.2329b5a2.svg";